<template>
    <div
        v-if="visible"
        class="fixed flex inset-0 z-[2001] items-center justify-center bg-black/70"
        @click.self="handleClose"
    >
        <div
            class="pop-gradient bg-[#1c1c20] rounded-[24px] px-5 lg:px-[30px] py-[30px] w-[90vw] sm:w-[520px] lg:w-[600px] mx-4 shadow-2xl"
            @click.stop
        >
            <div class="flex relative z-10 flex-col">
                <div class="w-ful flex justify-between">
                    <span class="text-[20px] font-medium text-[#fff]">{{
                        t('common.aiReversalTitle')
                    }}</span>
                    <button
                        @click="handleClose"
                        class="w-6 h-6 flex items-center justify-center text-white hover:scale-105 hover:rotate-180 transition-all duration-200"
                    >
                        <img
                            src="@/assets/images/common/_close.webp"
                            alt="close"
                            class="w-[24px]"
                        />
                    </button>
                </div>
                <div class="flex flex-col gap-[10px]">
                    <ui-image-upload-single
                        v-model:image_url="image_url"
                        v-model:image_size="image_size"
                        show_type="prompt_reversal"
                        :show_label="false"
                    ></ui-image-upload-single>
                    <tool-prompt-textarea
                        v-model:prompt="reversal_prompt"
                        :is_show_placeholder="false"
                        :is_show_recommend="false"
                        :is_show_reversal="false"
                        :is_disabled="!reversal_prompt?.length"
                        show_type="prompt_reversal"
                    ></tool-prompt-textarea>
                    <button
                        class="mt-5 generate bg-create-btn w-full disabled:opacity-50 disabled:cursor-not-allowed h-[52px] text-black rounded-[10px] flex items-center justify-center disabled:hover:scale-100 hover:scale-105 transition-all duration-300 cursor-pointer gap-2"
                        :disabled="loading || !image_url"
                        @click="handleCreate"
                    >
                        <template v-if="loading">
                            <svg
                                class="animate-spin h-5 w-5"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                            >
                                <circle
                                    class="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    stroke-width="4"
                                ></circle>
                                <path
                                    class="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                ></path>
                            </svg>
                            <span>{{ t('common.analyzing') }}</span>
                        </template>
                        <template v-else>
                            <img
                                src="~/assets/images/common/create_btn.svg"
                                alt="create"
                                aria-hidden="true"
                                role="presentation"
                                class="w-6 h-6"
                            />
                            <span>{{
                                show_apply_btn
                                    ? t('common.use')
                                    : t('common.startReversal')
                            }}</span>
                            <span
                                v-if="!show_apply_btn"
                                class="flex items-center justify-center"
                            >
                                <img
                                    src="~/assets/images/common/coin.webp"
                                    alt="credit"
                                    class="w-4 h-4 mr-1"
                                />
                                1
                            </span>
                        </template>
                    </button>

                    <!-- 修改 验证刷新后余额 -->        
                    <!-- <div v-if="userstore.isloggedin" class="mt-2 text-xs text-white/70">
                        余额：{{ userstore.balance }}
                    </div> -->
                    <!-- ======================================== -->
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useI18n } from '~/composables/useI18n'
import { computed, onMounted, onUnmounted, ref, watch } from 'vue'
import { useUserStore } from '~/stores/user'
import { imagePromptReversalApi } from '~/api/image-tools'

const loading = ref<boolean>(false)
const visible = defineModel<boolean>('visible', { required: true })
const userStore = useUserStore()

const reversal_prompt = ref<string>('')
const { t, locale } = useI18n()

/**
 * 处理关闭弹窗
 */
const handleClose = () => {
    visible.value = false
    guess_prompt.value = ''
    show_use_btn.value = false
    image_url.value = ''
    image_size.value = 0
}
const image_url = ref<string>('')

const guess_prompt = ref<string>('')

const show_use_btn = ref<boolean>(false)

const image_size = ref<number>(0)

const emit = defineEmits(['apply'])
// 应用反推提示词
const handleApplyReversalPrompt = () => {
    // reversal_prompt.value = guess_prompt.value
    emit('apply', reversal_prompt.value)
    handleClose()
}

const handleCreate = async () => {
    // 如果当前是使用按钮，则直接使用
    if (show_use_btn.value) {
        handleApplyReversalPrompt()
        return
    }
    if (loading.value) return
    loading.value = true
    guess_prompt.value = ''
    reversal_prompt.value = ''
    analyticsEvent('click_tool_page_common_create', {
        tool_name: 'image_prompt_reversal',
    })

    try {
        const res: any = await imagePromptReversalApi({
            image_url: image_url.value,
            copyright_protection: false,
            public_visible: true,
            language: locale.value,
            image_size: +image_size.value,
        })
        if (image_url.value) {
            guess_prompt.value = res.data?.prompt
            reversal_prompt.value = guess_prompt.value
            show_use_btn.value = true
        }
    } catch (error) {
        console.error('Failed to guess prompt:', error)
    } finally {
        loading.value = false

        // 修改 - 刷新余额
        if (userStore.isLoggedIn) {
            await userStore.getBalance()
        }
        // ==============================================
    }
}

const show_apply_btn = computed(() => {
    return show_use_btn.value && reversal_prompt.value
})

onUnmounted(() => {})

const is_client = import.meta.client
watch(
    () => visible.value,
    newVal => {
        if (!is_client) return
        if (!newVal) {
            document.body.style.overflow = 'auto'
            reversal_prompt.value = ''
            loading.value = false
        } else {
            document.body.style.overflow = 'hidden'
        }
    }
)

watch(
    () => image_url.value,
    newVal => {
        show_use_btn.value = false
    }
)

watch(
    () => reversal_prompt.value,
    newVal => {
        if (newVal?.length) {
            show_use_btn.value = true
        } else {
            show_use_btn.value = false
        }
    }
)
</script>

<style scoped lang="less">
/* 自定义动画 */
@keyframes fadeIn {
    from {
        opacity: 0;
        transform: scale(0.9);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
}

.fixed {
    animation: fadeIn 0.3s ease-out;
}

.recharge-btn {
    background: theme('backgroundColor.active-bg');
}

:deep(.el-loading-mask) {
    background: transparent;
}

.pay-loading {
    animation: loading-animation 2.5s infinite;
}

@keyframes loading-animation {
    0% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.1);
    }
    100% {
        transform: scale(1);
    }
}

.shake-animation {
    animation: shake-animation 0.3s cubic-bezier(0.39, 0.575, 0.565, 1);
}

@keyframes shake-animation {
    0% {
        transform: translateX(0);
    }
    25% {
        transform: translateX(-20px);
    }
    50% {
        transform: translateX(0);
    }
    75% {
        transform: translateX(20px);
    }
    100% {
        transform: translateX(0);
    }
}

.pop-gradient::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 20px;
    padding: 1px;
    background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0.1) 0%,
        transparent 100%
    );
    -webkit-mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    z-index: 1;
}
</style>
